export default {
  userLogin: 'USER_LOGIN',
  userLoginSuccess: 'USER_LOGIN_SUCCESS',
  userLoginFailed: 'USER_LOGIN_FAILED',
  setCurrentUser: 'SET_CURRENT_USER',
  setMealTypes: 'SET_MEAL_TYPES',
  logoutUser: 'LOGOUT_USER'
};
